<div class="business-interests-container" class="container-fluid" [formGroup]="formGroup">
    <div class="section-card">
        <p class="note">If the answer to any of the following 2 questions is in the affirmative, please complete and
            attach “Declaration of
            Business Interest(s) & Shareholding(s)/Ownership Form”.

        </p>
    </div>
    <div class="check-list">
        <ol class="custom-list">
            <li>
                <div class="row">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Do you hold any directorship/ sole proprietorship/ partnership/ other business interests
                            in
                            any entity in Singapore or elsewhere?</span>
                    </div>

                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0" required>
                        <mat-checkbox #businessInterests_1 [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_1')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'businessInterests_1',1)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_1')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'businessInterests_1',1)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['businessInterests_1'].value == true && businessInterests_1.checked ){
                    <div>
                        <mat-label>If Yes, please specify the total number of entities:</mat-label>
                        <input matInput formControlName="businessInterestsyes_1" type="text"
                            (input)="addbusinessInterests_1_Files(this.formGroup.get('businessInterestsyes_1')?.value)"
                            maxlength="1"
                            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 43" />
                        @if(this.formGroup.controls["businessInterestsyes_1"].invalid
                        && (this.formGroup.controls["businessInterestsyes_1"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["businessInterestsyes_1"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>

                    <div formArrayName="businessInterests_1_files">
                        <br>
                        @for(attachment of businessInterests_1_files.controls;track attachment; let j = $index){
                        <div class="row g-3 m-1" [formGroupName]="j">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                                <mat-label class="field-label">Attachment (ACRA)</mat-label>
                                <div class="upload-container">
                                    <div class="upload-box">
                                        <input type="file" id="attachment1_ACRA" accept=".pdf,.jpg,.jpeg,.png"
                                            [disabled]="readonly()"
                                            (change)="onFileChange($event,1,'attachment1_ACRA','attachment1_ACRA_file','businessInterests_1',j)">
                                        <input type="text" formControlName="attachment1_ACRA" hidden>
                                        @let attachment1_ACRA = attachment.get('attachment1_ACRA');

                                        <!-- Show filename OR placeholder -->
                                        @if(!attachment1_ACRA?.value){
                                        <span>
                                            Choose a file
                                        </span>
                                        }
                                        @if(attachment1_ACRA?.value){
                                        <div class="attachment-row">
                                            <span class="file-name">
                                                {{ attachment1_ACRA?.value }}
                                            </span>
                                            @if(readonly() === false){
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="removeFile('attachment1_ACRA','attachment1_ACRA_file','businessInterests_1',1,j)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            }
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="previewAttachment('attachment1_ACRA','businessInterests_1',1,j)">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if(attachment1_ACRA?.invalid
                                && (attachment1_ACRA?.touched)
                                ) {
                                <mat-error>
                                    @if(attachment1_ACRA?.errors?.["required"]) {
                                    <span class="field-required">{{message}}</span>
                                    }@else if(attachment1_ACRA?.errors?.['invalidType']){
                                    <span class="field-required">Only PDF, JPG, PNG files are allowed.</span>
                                    }
                                    @else if(attachment1_ACRA?.errors?.['maxSize']){
                                    <span class="field-required">File size must be less than or equal to 5MB.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                                <mat-label class="field-label">Attachment (Business declaration form)
                                    @if(readonly() === false){
                                    <span class="download-btn" (click)="downloadForm()">Download Forms</span>
                                    }
                                </mat-label>
                                <div class="upload-container">
                                    <div class="upload-box">
                                        <input type="file" id="attachment1_Businessdeclarationform"
                                            accept=".pdf,.jpg,.jpeg,.png" [disabled]="readonly()"
                                            (change)="onFileChange($event,1,'attachment1_Businessdeclarationform','attachment1_Businessdeclarationformfile','businessInterests_1_2',j)">
                                        <input type="text" formControlName="attachment1_Businessdeclarationform" hidden>
                                        @let attachment1_Businessdeclarationform =
                                        attachment.get('attachment1_Businessdeclarationform');
                                        <!-- Show filename OR placeholder -->
                                        @if(!attachment1_Businessdeclarationform?.value){
                                        <span>
                                            Choose a file
                                        </span>
                                        }
                                        @if(attachment1_Businessdeclarationform?.value){
                                        <div class="attachment-row">
                                            <span class="file-name">
                                                {{ attachment1_Businessdeclarationform?.value }}
                                            </span>
                                            @if(readonly() === false){
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="removeFile('attachment1_Businessdeclarationform','attachment1_Businessdeclarationformfile','businessInterests_1_2',1,j)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            }
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="previewAttachment('attachment1_Businessdeclarationform','businessInterests_1_2',1,j)">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if(attachment1_Businessdeclarationform?.invalid
                                && (attachment1_Businessdeclarationform?.touched ||
                                attachment1_Businessdeclarationform?.dirty)
                                ) {
                                <mat-error>
                                    @if(attachment1_Businessdeclarationform?.errors?.["required"])
                                    {
                                    <span class="field-required">{{message}}</span>
                                    }@else if(attachment1_Businessdeclarationform?.errors?.['invalidType']){
                                    <span class="field-required">Only PDF, JPG, PNG files are allowed.</span>
                                    }@else if(attachment1_Businessdeclarationform?.errors?.['maxSize']){
                                    <span class="field-required">File size must be less than or equal to 5MB.</span>
                                    }@else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if(this.formGroup.controls["businessInterests_1"].invalid
                    && (this.formGroup.controls["businessInterests_1"].touched)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["businessInterests_1"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
            <li>
                <div class="row" required>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Do you have any shareholdings/ownership where 1% or more of the shareholdings are
                            held by you in any entity in Singapore or elsewhere? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #businessInterests_2 [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_2')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'businessInterests_2',2)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_2')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'businessInterests_2',2)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['businessInterests_2'].value == true && businessInterests_2.checked){
                    <div>
                        <mat-label>If Yes, please specify the total number of entities:</mat-label>
                        <input matInput formControlName="businessInterestsyes_2" type="text" />
                        @if(this.formGroup.controls["businessInterestsyes_2"].invalid
                        && (this.formGroup.controls["businessInterestsyes_2"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["businessInterestsyes_2"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                    @if(this.formGroup.controls["businessInterests_2"].invalid
                    && (this.formGroup.controls["businessInterests_2"].touched)
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["businessInterests_2"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
            <li>
                <div class="row" required>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Does any of your connected persons* hold any directorship/ sole proprietorship/
                            partnership/ other business interests in any entity in Singapore or elsewhere which has
                            business activities with PIAS? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #businessInterests_3 [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_3')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'businessInterests_3',3)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_3')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'businessInterests_3',3)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['businessInterests_3'].value == true && businessInterests_3.checked){
                    <div>
                        <mat-label>If Yes, please specify the total number of entities:</mat-label>
                        <input matInput formControlName="businessInterestsyes_3" type="text" maxlength="1"
                            (input)="addbusinessInterests_3_Files(this.formGroup.get('businessInterestsyes_3')?.value)"
                            onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 43" />
                        @if(this.formGroup.controls["businessInterestsyes_3"].invalid
                        && (this.formGroup.controls["businessInterestsyes_3"].touched)
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["businessInterestsyes_3"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    <div formArrayName="businessInterests_3_files">
                        <br>
                        @for(attachment of businessInterests_3_files.controls;track attachment; let j = $index){
                        <div class="row g-3 m-1" [formGroupName]="j">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                                <mat-label class="field-label">Attachment (ACRA)</mat-label>
                                <div class="upload-container">
                                    <div class="upload-box">
                                        <input type="file" id="attachment2_ACRA" accept=".pdf,.jpg,.jpeg,.png"
                                            [disabled]="readonly()"
                                            (change)="onFileChange($event,3,'attachment2_ACRA','attachment2_ACRA_file','businessInterests_3',j)">
                                        <input type="text" formControlName="attachment2_ACRA" hidden>
                                        @let attachment2_ACRA = attachment.get('attachment2_ACRA');

                                        <!-- Show filename OR placeholder -->
                                        @if(!attachment2_ACRA?.value){
                                        <span>
                                            Choose a file
                                        </span>
                                        }
                                        @if(attachment2_ACRA?.value){
                                        <div class="attachment-row">
                                            <span class="file-name">
                                                {{ attachment2_ACRA?.value }}
                                            </span>
                                            @if(readonly() === false){
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="removeFile('attachment2_ACRA','attachment2_ACRA_file','businessInterests_3',3,j)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            }
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)=" previewAttachment('attachment2_ACRA','businessInterests_3',3,j)">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if(attachment2_ACRA?.invalid
                                && (attachment2_ACRA?.touched ||
                                attachment2_ACRA?.dirty)
                                ) {
                                <mat-error>
                                    @if(attachment2_ACRA?.errors?.["required"]) {
                                    <span class="field-required">{{message}}</span>
                                    }
                                    @else if(attachment2_ACRA?.errors?.['invalidType']){
                                    <span class="field-required">Only PDF, JPG, PNG files are allowed.</span>
                                    }
                                    @else if(attachment2_ACRA?.errors?.['maxSize']){
                                    <span class="field-required">File size must be less than or equal to 5MB.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-xxl-6 m-0">
                                <mat-label class="field-label">Attachment (Business declaration form)
                                    @if(readonly() === false){
                                    <span class="download-btn" (click)="downloadForm()">Download Forms</span>
                                    }
                                </mat-label>
                                <div class="upload-container">
                                    <div class="upload-box">
                                        <input type="file" id="attachment2_Businessdeclarationform"
                                            [disabled]="readonly()" accept=".pdf,.jpg,.jpeg,.png"
                                            (change)="onFileChange($event,3,'attachment2_Businessdeclarationform','attachment2_Businessdeclarationformfile','businessInterests_3_2',j)">
                                        <input type="text" formControlName="attachment2_Businessdeclarationform" hidden>
                                        @let attachment2_Businessdeclarationform =
                                        attachment.get('attachment2_Businessdeclarationform');
                                        <!-- Show filename OR placeholder -->
                                        @if(!attachment2_Businessdeclarationform?.value){
                                        <span>
                                            Choose a file
                                        </span>
                                        }
                                        @if(attachment2_Businessdeclarationform?.value){
                                        <div class="attachment-row">
                                            <span class="file-name">
                                                {{ attachment2_Businessdeclarationform?.value }}
                                            </span>
                                            @if(readonly() === false){
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="removeFile('attachment2_Businessdeclarationform','attachment2_Businessdeclarationformfile','businessInterests_3_2',3,j)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                            }
                                            <button mat-icon-button color="primary" class="delete-btn"
                                                (click)="previewAttachment('attachment2_Businessdeclarationform','businessInterests_3_2',3,j)">
                                                <mat-icon>visibility</mat-icon>
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                @if(attachment2_Businessdeclarationform?.invalid
                                && (attachment2_Businessdeclarationform?.touched ||
                                attachment2_Businessdeclarationform?.dirty)
                                ) {
                                <mat-error>
                                    @if(attachment2_Businessdeclarationform?.errors?.["required"])
                                    {
                                    <span class="field-required">{{message}}</span>
                                    }@else if(attachment2_Businessdeclarationform?.errors?.['invalidType']){
                                    <span class="field-required">Only PDF, JPG, PNG files are allowed.</span>
                                    }
                                    @else if(attachment2_Businessdeclarationform?.errors?.['maxSize']){
                                    <span class="field-required">File size must be less than or equal to 5MB.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if(this.formGroup.controls["businessInterests_3"].invalid
                    && (this.formGroup.controls["businessInterests_3"].touched )
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["businessInterests_3"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
            <li>
                <div class="row" required>
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xxl-10 m-0">
                        <span>Does any of your connected persons have any shareholdings where 1% or more of the
                            shareholdings are held by them in any entity in Singapore or elsewhere which has
                            business activities with PIAS? </span>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xxl-2 m-0">
                        <mat-checkbox #businessInterests_4 [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_4')?.value === true"
                            (change)="onCheckboxChange($event.checked, true,'businessInterests_4',4)">
                            Yes
                        </mat-checkbox>

                        <mat-checkbox [disabled]="this.readonly()"
                            [checked]="formGroup.get('businessInterests_4')?.value === false"
                            (change)="onCheckboxChange($event.checked, false,'businessInterests_4',4)">
                            No
                        </mat-checkbox>
                    </div>
                    @if(this.formGroup.controls['businessInterests_4'].value == true && businessInterests_4.checked){
                    <div>
                        <mat-label>If Yes, please specify the total number of entities:</mat-label>
                        <input matInput formControlName="businessInterestsyes_4" type="text" />
                        @if(this.formGroup.controls["businessInterestsyes_4"].invalid
                        && (this.formGroup.controls["businessInterestsyes_4"].touched )
                        ) {
                        <mat-error>
                            @if(this.formGroup.controls["businessInterestsyes_4"].errors?.["required"]) {
                            <span class="field-required">{{message}}</span>
                            }
                            @else {
                            <span></span>
                            }
                        </mat-error>
                        }
                    </div>
                    }
                    @if(this.formGroup.controls["businessInterests_4"].invalid
                    && (this.formGroup.controls["businessInterests_4"].touched )
                    ) {
                    <mat-error>
                        @if(this.formGroup.controls["businessInterests_4"].errors?.["required"]) {
                        <span class="field-required">{{message}}</span>
                        }
                        @else {
                        <span></span>
                        }
                    </mat-error>
                    }
                </div>
            </li>
        </ol>
    </div>

    <p class="note">*Connected persons – Spouse, civil partner, any person who lives with the director / employee as a
        partner in an enduring
        relationship (excluding grandparents, grandchildren, sister, brother, aunt, uncle, niece or nephew), children
        and stepchildren of
        any age, director’s / employees’ parents and children or step children of a person who lives with the director
        under the age of
        18.

    </p>
    @if(readonly() === false){
    @if(isVisible() === true){
    <div class="editor-actions">
        <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
        <button type="button" class="save-btn" (click)="saveSection()">
            <mat-icon>save</mat-icon>Save</button>
    </div>
    }@else{
    <!-- Form Actions -->
    <div class="form-actions mt-4 text-end">
        <!-- [disabled]="formGroup.invalid" -->
        <button mat-raised-button class="save-btn" (click)="saveAndContinue()">
            <span>Save & Continue</span>
            <mat-icon>arrow_forward</mat-icon>
        </button>

    </div>
    }
}

</div>